import React from 'react';
import { useState, useEffect } from "react";
import { HeaderHeader, HeaderContainer, HeaderLogotDiv, HeaderTextDiv, HeaderLinktDiv } from './styles';

import LogoDesktop from "../../assets/icons/logotipo.svg";
import LogoMobile from "../../assets/icons/logotipo-mobile.svg";


// header
const Header = ()  => {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 1024);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 1024);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // render
  return (
    <HeaderHeader>
      <HeaderContainer>
        <HeaderLogotDiv>
          <h1>
            <a href="/">
              <img src={isMobile ? LogoMobile : LogoDesktop} alt="Brava Energia" />
            </a>
            Brava Energia - Produtos
          </h1>
        </HeaderLogotDiv>

        <HeaderTextDiv>
          <strong>Produtos</strong>
          <p>Informações em atendimento à Resolução ANP nº 795/2019</p>
        </HeaderTextDiv>

        <HeaderLinktDiv>
          <a href="//www.bravaenergia.com">Voltar para o site da Brava</a>
        </HeaderLinktDiv>
      </HeaderContainer>
    </HeaderHeader>
  );
};

export default Header;